// Business wall-clock helpers, pinned to Indiana time — the same clock the
// cron worker uses for reminders. Pinning (instead of the device timezone)
// keeps "due now" badges, past-date validation, and scheduled pushes in
// agreement even when a phone is traveling outside Eastern time.
const TZ = "America/Indiana/Indianapolis";

function partsFor(d = new Date()) {
  const p = Object.fromEntries(
    new Intl.DateTimeFormat("en-US", {
      timeZone: TZ,
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    })
      .formatToParts(d)
      .map((x) => [x.type, x.value]),
  );
  return { date: `${p.year}-${p.month}-${p.day}`, hm: `${p.hour}:${p.minute}` };
}

export const localToday = () => partsFor().date;
export const localNowHM = () => partsFor().hm;
export const localNowStr = () => {
  const p = partsFor();
  return `${p.date} ${p.hm}`;
};

// HH:MM some hours from now, on the business clock.
export const hmPlus = (hours) => partsFor(new Date(Date.now() + hours * 3600e3)).hm;

// YYYY-MM-DD some days from now, on the business clock.
export const localDatePlus = (days) => partsFor(new Date(Date.now() + days * 86400e3)).date;

// The next date (YYYY-MM-DD) an HH:MM slot occurs: today if it hasn't passed
// yet on the business clock, otherwise tomorrow.
export function nextDateForTime(hm) {
  const p = partsFor();
  return hm > p.hm ? p.date : localDatePlus(1);
}

// "2026-07-14" -> "Mon, Jul 14". Built from parts so the device timezone
// can't shift the day.
export function fmtDay(dateStr) {
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
}

export function fmt12(hm) {
  if (!hm) return "";
  const [h, m] = hm.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
}
